
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $f7662eea5fe8ba4c$exports = {};
var $f7662eea5fe8ba4c$var$r = [];
function $f7662eea5fe8ba4c$var$t(t) {
    var o, n, u = [], c = function(...o) {
        var n;
        return o.length ? function(r) {
            if (r !== t || null !== t && "object" == typeof t) {
                var o = t;
                t = r;
                for(let r = u.length - 1; r > -1; r--)u[r](t, o);
            }
        }(o[0]) : ((n = $f7662eea5fe8ba4c$var$r[$f7662eea5fe8ba4c$var$r.length - 1]) && e(n), t);
    }, e = (r, o)=>{
        ~u.indexOf(r) || u.push(r), o && r(t);
    };
    return c.subscribe = e, c.unsubscribe = (r)=>{
        (n = (o = u).indexOf(r)) > -1 && o.splice(n, 1);
    }, c;
}
$f7662eea5fe8ba4c$var$t.computed = (o)=>{
    var n = $f7662eea5fe8ba4c$var$t();
    return function t() {
        var u, c;
        !function(o) {
            if ($f7662eea5fe8ba4c$var$r.indexOf(t) > -1) throw Error("Circular computation");
        }(), $f7662eea5fe8ba4c$var$r.push(t);
        try {
            c = o();
        } catch (r) {
            u = r;
        }
        if ($f7662eea5fe8ba4c$var$r.pop(), u) throw u;
        n(c);
    }(), n;
}, $f7662eea5fe8ba4c$var$t.from = (r)=>{
    var o = $f7662eea5fe8ba4c$var$t();
    return r(o), o;
}, $f7662eea5fe8ba4c$exports = $f7662eea5fe8ba4c$var$t;


const $9ebf0a476e33291b$var$fileType = {
    type: "text/plain;charset=utf-8"
};
const $9ebf0a476e33291b$var$anchor = document.createElement("a");
function $9ebf0a476e33291b$export$72c04af63de9061a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>resolve(reader.result);
        reader.onerror = (err)=>reject(err);
        reader.readAsText(file);
    });
}
function $9ebf0a476e33291b$export$e620933a198f7bc(text, name) {
    const blob = new Blob([
        text
    ], $9ebf0a476e33291b$var$fileType);
    const objURL = URL.createObjectURL(blob);
    $9ebf0a476e33291b$var$anchor.href = objURL;
    $9ebf0a476e33291b$var$anchor.download = name;
    $9ebf0a476e33291b$var$anchor.click();
    // Prevents memory leaks
    URL.revokeObjectURL(objURL);
}
function $9ebf0a476e33291b$export$8eb38b2a7b91ac21(text) {
    const trimPoint = text.match(/(\s)+$/g);
    if (trimPoint) return text.substr(0, trimPoint.index);
    else return text;
}
function $9ebf0a476e33291b$export$d614ee83a8a0f115(text) {
    return text.split(/\r\n|\r|\n/);
}



var $0aeb1b3782d594c9$export$252f25ea043488ae;
(function(LockStates) {
    LockStates[LockStates["WAITING"] = 0] = "WAITING";
    LockStates[LockStates["HAS_LOCK"] = 1] = "HAS_LOCK";
    LockStates[LockStates["LOCK_REJECTED"] = 2] = "LOCK_REJECTED";
    LockStates[LockStates["DISABLED"] = 3] = "DISABLED";
    LockStates[LockStates["RELEASED"] = 4] = "RELEASED";
})($0aeb1b3782d594c9$export$252f25ea043488ae || ($0aeb1b3782d594c9$export$252f25ea043488ae = {}));
class $0aeb1b3782d594c9$export$7f17db3bc58b5c60 {
    constructor(name){
        this.name = name;
        this.state = (0, (/*@__PURE__*/$parcel$interopDefault($f7662eea5fe8ba4c$exports)))("locks" in window.navigator ? 0 : 3);
        this.releaseLock = ()=>{};
        if (this.state() !== 3) {
            console.log({
                INFO: "Acquiring lock"
            });
            this.acquireLock();
        } else console.log({
            INFO: "Web Locks API missing / disabled"
        });
    }
    readDocument() {
        return window.localStorage.getItem(this.name);
    }
    writeDocument(text) {
        try {
            return window.localStorage.setItem(this.name, text);
        } catch  {
        // Could throw if out of storage - ignore in this case
        }
    }
    acquireLock() {
        window.navigator.locks.request(this.name, {
            ifAvailable: true
        }, (lock)=>{
            if (!lock) {
                console.log({
                    INFO: "Unable to acquire lock"
                });
                this.state(2);
            } else {
                console.log({
                    INFO: "Acquired lock"
                });
                this.state(1);
                // Hold the lock with a promise that won't resolve until the class is torn down
                return new Promise((resolve)=>{
                    this.releaseLock = ()=>{
                        this.state(4);
                        resolve("Released lock");
                        console.log({
                            INFO: "Released lock"
                        });
                    };
                });
            }
        });
    }
}


const $a420e8f24595d678$export$d5479f9d07e31b27 = "Dead Simple Text.txt";
const $a420e8f24595d678$export$f6644f0f2c90144b = (0, (/*@__PURE__*/$parcel$interopDefault($f7662eea5fe8ba4c$exports)))({
    key: "__INIT"
});
class $a420e8f24595d678$export$7254cc27399e90bd {
    constructor(view, storage){
        this.view = view;
        this.storage = storage;
        $a420e8f24595d678$export$f6644f0f2c90144b.subscribe((event)=>this.handleUserEvents(event), true);
        storage.state.subscribe((event)=>this.handleStorageEvents(event), true);
    }
    async handleUserEvents(event) {
        console.log("handle user event:", event);
        switch(event.key){
            case "NEW_FILE":
                this.storage.releaseLock();
                this.view.setFilenameText("untitled.txt");
                this.view.setContent("");
                break;
            case "OPEN_FILE":
                this.storage.releaseLock();
                this.view.setFilenameText(event.file.name);
                this.view.setContent(await (0, $9ebf0a476e33291b$export$72c04af63de9061a)(event.file));
                this.view.focusContent();
                break;
            case "SAVE_FILE":
                {
                    const filename = this.view.getFilename();
                    if (filename.length) {
                        const text = this.view.getContent();
                        const trimmed = (0, $9ebf0a476e33291b$export$8eb38b2a7b91ac21)(text);
                        (0, $9ebf0a476e33291b$export$e620933a198f7bc)(trimmed, filename);
                    } else window.alert("Please provide a filename");
                    break;
                }
            case "INSERT_TAB":
                this.insertTab();
                break;
            case "UNINSERT_TAB":
                this.uninsertTab();
                break;
            case "TEXT_CHANGE":
                if (this.storage.state() === (0, $0aeb1b3782d594c9$export$252f25ea043488ae).HAS_LOCK) this.storage.writeDocument(this.view.getContent());
                break;
            case "CHANGE_FILE_NAME":
                // There are some rules for how we handle locks here:
                // - If the file is renamed from 'Dead Simple Text.txt', we release the lock and work on a fork
                // - If a file is renamed *to* 'Dead Simple Text.txt', we 'cancel' the rename
                if (this.storage.state() === (0, $0aeb1b3782d594c9$export$252f25ea043488ae).HAS_LOCK) {
                    if (event.name !== $a420e8f24595d678$export$d5479f9d07e31b27) this.storage.releaseLock();
                } else if (event.name === $a420e8f24595d678$export$d5479f9d07e31b27) this.view.setFilenameText("untitled.txt");
                break;
        }
    }
    handleStorageEvents(event) {
        console.log("handle storage event:", event);
        switch(event){
            case (0, $0aeb1b3782d594c9$export$252f25ea043488ae).DISABLED:
            // Browser does not support web locks API:
            case (0, $0aeb1b3782d594c9$export$252f25ea043488ae).LOCK_REJECTED:
                // Another tab has the lock:
                window.setTimeout(()=>{
                    // Timeout handles case where browser 'duplicate tab' is still manipulating the DOM
                    this.view.setFilenameText("untitled.txt");
                }, 10);
                break;
            case (0, $0aeb1b3782d594c9$export$252f25ea043488ae).HAS_LOCK:
                // We have the lock
                this.view.setFilenameText($a420e8f24595d678$export$d5479f9d07e31b27);
                this.view.setContent(this.storage.readDocument() || $a420e8f24595d678$var$getInitJournal());
                break;
        }
        if (event !== (0, $0aeb1b3782d594c9$export$252f25ea043488ae).WAITING) this.view.setUIReady();
    }
    insertTab() {
        const [cursorStart, cursorEnd] = this.view.getCursor();
        const text = this.view.getContent();
        const tab = "    ";
        if (cursorStart == cursorEnd) document.execCommand("insertText", undefined, tab);
        else {
            const lines = (0, $9ebf0a476e33291b$export$d614ee83a8a0f115)(text);
            let newText = "";
            let lastLineEnd = 0;
            let tabsInserted = 0;
            let startOnLineBreak = false;
            for(let i = 0; i < lines.length; i++){
                const start = lastLineEnd;
                const end = lastLineEnd + lines[i].length + 1;
                if (i > 0) newText += "\n";
                if (end > cursorStart && start < cursorEnd) {
                    newText += tab;
                    tabsInserted++;
                }
                if (start == cursorStart) startOnLineBreak = true;
                newText += lines[i];
                lastLineEnd = end;
            }
            document.execCommand("selectAll");
            document.execCommand("insertText", undefined, newText);
            const nextCursorStart = startOnLineBreak ? cursorStart : cursorStart + tab.length;
            const nextCursorEnd = cursorEnd + tabsInserted * tab.length;
            this.view.setCursor(nextCursorStart, nextCursorEnd);
        }
    }
    uninsertTab() {
        const [cursorStart, cursorEnd] = this.view.getCursor();
        const text = this.view.getContent();
        const initialSpaces = /^    /g;
        if (cursorStart != cursorEnd) {
            const lines = (0, $9ebf0a476e33291b$export$d614ee83a8a0f115)(text);
            let newText = "";
            let lastLineEnd = 0;
            let spacesRemoved = 0;
            let startOnLineBreak = false;
            for(let i = 0; i < lines.length; i++){
                const line = lines[i];
                const start = lastLineEnd;
                const end = lastLineEnd + line.length + 1;
                let lineTransformed = line;
                if (i > 0) newText += "\n";
                if (end > cursorStart && start < cursorEnd) lineTransformed = line.replace(initialSpaces, "");
                if (start == cursorStart) startOnLineBreak = true;
                newText += lineTransformed;
                spacesRemoved += line.length - lineTransformed.length;
                lastLineEnd = end;
            }
            document.execCommand("selectAll");
            document.execCommand("insertText", undefined, newText);
            const nextCursorStart = startOnLineBreak ? cursorStart : cursorStart - 4;
            const nextCursorEnd = cursorEnd - spacesRemoved;
            this.view.setCursor(nextCursorStart, nextCursorEnd);
        }
    }
}
function $a420e8f24595d678$var$getInitJournal() {
    return [
        "Welcome to Dead Simple Text!",
        "",
        'This default document is your "journal", which is kept in sync with your browser storage. Any changes you make',
        `to "Dead Simple Text.txt" will be kept for your next visit.`,
        "",
        `If you change the document name (top right) you will begin working on a separate document; this won't be synced, but`,
        `you can download it using the Save button.`,
        "",
        "https://github.com/jbreckmckye/dead-simple-text"
    ].join("\n");
}



class $e79b70a3675d8701$export$27a5bd065ad55220 {
    constructor(){
        this.focusContent = ()=>{
            this.textarea.focus();
        };
        this.getContent = ()=>this.textarea.value;
        this.getCursor = ()=>[
                this.textarea.selectionStart,
                this.textarea.selectionEnd
            ];
        this.getFilename = ()=>this.filename.value;
        this.getCursorPosition = ()=>this.textarea.selectionStart;
        this.setContent = (text)=>{
            // Mutations here will break the textarea undo/redo stack.
            // Only use this when initialising a document. Otherwise, use document.execCommand.
            this.textarea.value = text;
        };
        this.setCursor = (start, end)=>{
            this.textarea.setSelectionRange(start, end);
        };
        this.setFilenameText = (text)=>{
            this.filename.value = text;
        };
        this.setUIReady = ()=>{
            this.toolbar.classList.remove("toolbar--loading");
        };
        this.textChangedFlag = false;
        this.toolbar = this.getEl("toolbar");
        this.filename = this.getEl("filename");
        this.fileNew = this.getEl("fileNew");
        this.fileOpen = this.getEl("fileOpen");
        this.fileSave = this.getEl("fileSave");
        this.textarea = this.getEl("textarea");
        this.fileOpenHelper = document.createElement("input");
        this.fileOpenHelper.type = "file";
        this.fileOpenHelper.accept = ".css,.markdown,.md,.js,.json,.jsx,.scss,.svg,.ts,.tsx,.txt,.xml";
        this.shiftOn = false;
        this.addEvents();
    }
    getEl(id) {
        const result = document.getElementById(id);
        if (!result) throw new Error(`No element found for selector ${id}`);
        else return result;
    }
    addEvents() {
        this.fileOpen.addEventListener("click", ()=>{
            this.fileOpenHelper.click();
        }, false);
        this.fileOpenHelper.addEventListener("change", ()=>{
            if (this.fileOpenHelper.files) (0, $a420e8f24595d678$export$f6644f0f2c90144b)({
                key: "OPEN_FILE",
                file: this.fileOpenHelper.files[0]
            });
        }, false);
        this.fileSave.addEventListener("click", ()=>{
            (0, $a420e8f24595d678$export$f6644f0f2c90144b)({
                key: "SAVE_FILE"
            });
        });
        this.fileNew.addEventListener("click", ()=>{
            (0, $a420e8f24595d678$export$f6644f0f2c90144b)({
                key: "NEW_FILE"
            });
        });
        this.filename.addEventListener("change", (e)=>{
            const input = e.target;
            (0, $a420e8f24595d678$export$f6644f0f2c90144b)({
                key: "CHANGE_FILE_NAME",
                name: input.value
            });
        });
        this.textarea.addEventListener("input", ()=>{
            if (!this.textChangedFlag) this.textChangedFlag = true;
        });
        this.textarea.addEventListener("keydown", (e)=>{
            // Trap tab
            if (e.key == "Tab") {
                e.preventDefault();
                if (!this.shiftOn) (0, $a420e8f24595d678$export$f6644f0f2c90144b)({
                    key: "INSERT_TAB"
                });
                else (0, $a420e8f24595d678$export$f6644f0f2c90144b)({
                    key: "UNINSERT_TAB"
                });
            // Untrap tab
            } else if (e.key == "F6") {
                e.preventDefault();
                this.fileNew.focus();
            // Switch shift
            } else if (e.key == "Shift") // No prevent default
            this.shiftOn = true;
        });
        this.textarea.addEventListener("keyup", (e)=>{
            // Switch shift
            if (e.key == "Shift") this.shiftOn = false;
        });
        this.textarea.addEventListener("change", ()=>{
            (0, $a420e8f24595d678$export$f6644f0f2c90144b)({
                key: "TEXT_CHANGE"
            });
        });
    }
}



const $cbb8114b66dd9fa5$var$view = new (0, $e79b70a3675d8701$export$27a5bd065ad55220)();
const $cbb8114b66dd9fa5$var$storage = new (0, $0aeb1b3782d594c9$export$7f17db3bc58b5c60)((0, $a420e8f24595d678$export$d5479f9d07e31b27));
new (0, $a420e8f24595d678$export$7254cc27399e90bd)($cbb8114b66dd9fa5$var$view, $cbb8114b66dd9fa5$var$storage);


//# sourceMappingURL=index.6e1a0ad3.js.map
